<template>
  <v-combobox
    v-model="editing"
    @change="event(editing.text)"
    :items="items"
    dense
    solo
    :rules="rules"
  >
    <template v-slot:item="{ index, item }">
      <v-list-item-action @click.stop v-if="editing === item && item.edited == true">
        <v-text-field
          v-model="item.text"
          autofocus
          background-color="transparent"
          hide-details
          solo
          @press.enter="edit(item, index)"
        ></v-text-field>
      </v-list-item-action>
      <v-chip v-else :color="'blue lighten-2'" dark label small>
        {{ item.text }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-list-item-action @click.stop>
        <v-btn
          v-if="item.text == 'Novo' || item.edited == true"
          icon
          @click.stop.prevent="edit(item, index)"
        >
          <v-icon>{{ editing !== item ? "mdi-pencil" : "mdi-check" }}</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    items: Array,
    event: Function,
    rules: Array,
  },
  data() {
    return {
      editing: null,
    };
  },
  methods: {
    edit(item) {
      if (!this.editing) {
        if(item.text == 'Novo'){
          item.text = '';
        }
        this.editing = item;
        this.editing.edited = true;
      } else {
        this.editing = null;
      }
    },
  },
};
</script>